<child-header title="Microsoft Partner Agreement" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <p>
      This MPN does not appear to have accepted the new Microsoft Partner Agreement.
      All Microsoft partners must accept the Microsoft Partner Agreement prior to the
      31st of January 2020 to continue transacting Microsoft CSP.
      <br>
      <br>
      To find out more click <a class="red-bold"
        [href]="url"
        target="_blank">here</a>
    </p>
  </div>
</div>